"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.successMatcher = exports.errorMatcher = exports.commonFormControlSuccessStateMatcher = exports.commonFormControlErrorStateMatcher = void 0;
const { pureComputed, unwrap } = ko;
function commonFormControlErrorStateMatcher(condition) {
    return function (formControl) {
        return pureComputed(function () {
            var isConditionMet = typeof condition === "function" ? condition() : true;
            return ("isValid" in formControl && isConditionMet && !formControl.isValid());
        });
    };
}
exports.commonFormControlErrorStateMatcher = commonFormControlErrorStateMatcher;
function commonFormControlSuccessStateMatcher(condition) {
    return function (formControl) {
        return pureComputed(function () {
            var isConditionMet = typeof condition === "function" ? condition() : true;
            return ("isValid" in formControl && isConditionMet && formControl.isValid());
        });
    };
}
exports.commonFormControlSuccessStateMatcher = commonFormControlSuccessStateMatcher;
const errorMatcher = (condition) => {
    return (formControl) => {
        return pureComputed(() => {
            if (!formControl)
                return false;
            if (!("isValid" in formControl))
                return false;
            const isMatch = !!unwrap(condition);
            if (!isMatch)
                return false;
            return !formControl.isValid();
        });
    };
};
exports.errorMatcher = errorMatcher;
const successMatcher = (condition) => {
    return (formControl) => {
        return pureComputed(() => {
            if (!formControl)
                return false;
            if (!("isValid" in formControl))
                return false;
            const isMatch = !!unwrap(condition);
            if (!isMatch)
                return false;
            return formControl.isValid();
        });
    };
};
exports.successMatcher = successMatcher;
